import type { GenieKnowledgeEntry } from '../../types';

export const carpalTunnelSyndrome: GenieKnowledgeEntry = {
  id: 'carpal_tunnel_syndrome',
  aliases: [
    'carpal_tunnel_syndrome_mild',
    'carpal_tunnel_syndrome_moderate',
    'carpal_tunnel_syndrome_severe',
  ],
  name: 'Síndrome del Túnel Carpiano',
  category: 'neuropatico',
  conversation: {
    headline:
      'Atrapamiento del mediano en la muñeca. Los comparativos mediano-ulnar al 4.º dedo son los más sensibles.',
    edxHighlights: [
      'Comparativo mediano-ulnar 4.º dedo: Δ latencia >0.4 ms = anormal',
      'Lumbrical-interóseo útil cuando el SNAP mediano está ausente',
      'Severidad: de comparativos anormales (leve) a CMAP reducido (severo)',
    ],
    pearls: [
      'Temperatura <32°C en MS prolonga latencias y simula STC falso positivo.',
      'Si mediano y ulnar están anormales, use comparativo mediano-radial al pulgar.',
    ],
    differentials: [
      { name: 'Polineuropatía', distinguishingHint: 'afectación simétrica bilateral de múltiples nervios' },
      { name: 'Radiculopatía C6-C7', distinguishingHint: 'EMG en músculos proximales del brazo alterado' },
    ],
    nextSteps: [
      'Correlacionar con parestesias nocturnas y distribución del mediano',
      'Grado EDX guía conservador vs descompresión quirúrgica',
    ],
  },
  detail: {
    summary:
      'Atrapamiento más frecuente (~40% de consultas EDX). Compresión del mediano bajo el retináculo flexor.',
  },
  orientationHints: {
    temporalFit: ['chronic'],
    whenToSuspect: 'Parestesias nocturnas en dedos mediano, debilidad tenar, Tinel/Phalen positivos',
  },
};
